import { render, staticRenderFns } from "./PdvDeliveryServices.vue?vue&type=template&id=36f452d1&scoped=true"
import script from "./PdvDeliveryServices.vue?vue&type=script&lang=js"
export * from "./PdvDeliveryServices.vue?vue&type=script&lang=js"
import style0 from "./PdvDeliveryServices.vue?vue&type=style&index=0&id=36f452d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f452d1",
  null
  
)

export default component.exports